import React from 'react';
import { AnimatedContainer } from '../Animated';
import { Route, Switch } from './Router';

function NavigatorSwitch(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Route, {
    render: function render(_ref2) {
      var location = _ref2.location;
      return /*#__PURE__*/React.createElement(AnimatedContainer, {
        exitBeforeEnter: true,
        initial: false
      }, /*#__PURE__*/React.createElement(Switch, {
        key: location.pathname,
        location: location
      }, children));
    }
  });
}

export default /*#__PURE__*/React.memo(NavigatorSwitch);